import { Input } from 'antd'
import styled from 'styled-components'

const StyledMenuTitleInput = styled(Input)`
  &.ant-input[disabled] {
    color: rgba(0, 0, 0, 0.85);
  }
`

export default StyledMenuTitleInput
